export const MEAL_TYPE_IDS = Object.freeze({
	OFFERS: 11,
})

export const PROMOTION_TYPES = Object.freeze({
	OFFERS: 'offers',
})

export const SCOPES = Object.freeze({
	BOKABORD: 'bokabord.se',
})

export const TAGS = Object.freeze({
	REGION: [8, 9, 10],
})
export const ALT_TYPE_IDS = Object.freeze({
	LAST_MINUTE: 3,
	EARLY_DINNER: 2,
	STANDARD: 1,
})

export const ALT_TYPES_DISCOUNTS = Object.freeze({
	[ALT_TYPE_IDS.EARLY_DINNER]: 0.25,
	[ALT_TYPE_IDS.LAST_MINUTE]: 0.30,
	[ALT_TYPE_IDS.STANDARD]: 0.25,
})
